// types
import { UserManagerSettings, WebStorageStateStore } from 'oidc-client';
import { ConfigProps } from 'types/config';

export const FIREBASE_API = {
    apiKey: 'AIzaSyBernKzdSojh_vWXBHt0aRhf5SC9VLChbM',
    authDomain: 'berry-material-react.firebaseapp.com',
    projectId: 'berry-material-react',
    storageBucket: 'berry-material-react.appspot.com',
    messagingSenderId: '901111229354',
    appId: '1:901111229354:web:a5ae5aa95486297d69d9d3',
    measurementId: 'G-MGJHSL8XW3'
};

// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = '';

export const DASHBOARD_PATH = '/home';

const odevConfig = window.odevConfig;

const location = window.location;
const hostName: string = `${location.protocol}//${location.host}`;

const authUrl: string = odevConfig?.IdentityServerUrl || process.env.REACT_APP_IDENTITY_SERVER_URL || '';
const serviceBaseUrl: string = odevConfig?.AppServiceBaseUrl || process.env.REACT_APP_SERVICE_BASE_URL || '';
const clientId: string = odevConfig?.IdentityServerClientId || process.env.REACT_APP_IDENTITY_CLIENT_ID || '';
const appVersion: string = odevConfig?.AppVersion || process.env.REACT_APP_VERSION || '';
const swVersion: string = odevConfig?.SWVersion || process.env.REACT_APP_SW_VERSION || '';
const grafanaUrl: string = odevConfig?.GrafanaUrl || process.env.REACT_APP_GRAFANA_URL || '';
const grafanaDashboardId: string = odevConfig?.GrafanaDashboardId || process.env.REACT_APP_GRAFANA_DASHBOARD_ID || '';
const grafanaDashboardName: string = odevConfig?.GrafanaDashboardName || process.env.REACT_APP_GRAFANA_DASHBOARD_NAME || '';
const grafanaAccessToken: string = odevConfig?.GrafanaAccessToken || process.env.REACT_APP_ACCESS_TOKEN || '';

const userManagerConfig: UserManagerSettings = {
    client_id: clientId,
    response_type: 'token id_token',
    scope: 'openid profile email',

    authority: authUrl,
    redirect_uri: `${hostName}/#/callback`,
    silent_redirect_uri: `${hostName}/#/silentRenew`,

    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    monitorSession: true,
    userStore: new WebStorageStateStore({ store: localStorage })
};

if (!authUrl) throw new Error("Missing env REACT_APP_IDENTITY_SERVER_URL or config value 'IdentityServerUrl'");
if (!serviceBaseUrl) throw new Error("Missing env REACT_APP_SERVICE_BASE_URL or config value 'AppServiceBaseUrl'");
if (!clientId) throw new Error("Missing env REACT_APP_IDENTITY_CLIENT_ID or config value 'IdentityServerClientId'");
if (!appVersion) throw new Error("Missing env REACT_APP_VERSION or config value 'appVersion'");
if (!swVersion) throw new Error("Missing env REACT_APP_SW_VERSION or config value 'SWVersion'");
if (!grafanaUrl) throw new Error("Missing env REACT_APP_GRAFANA_URL or config value 'GrafanaUrl'");
if (!grafanaDashboardId) throw new Error("Missing env REACT_APP_GRAFANA_DASHBOARD_ID or config value 'GrafanaDashboardId'");
if (!grafanaDashboardName) throw new Error("Missing env REACT_APP_GRAFANA_DASHBOARD_NAME or config value 'GrafanaDashboardName'");
if (!grafanaAccessToken) throw new Error("Missing env REACT_APP_ACCESS_TOKEN or config value 'GrafanaAccessToken'");

const config: ConfigProps = {
    navType: 'light', // light, dark
    locale: 'en', // 'en' - English, 'it' - Italian
    appVersion,
    swVersion,
    userManagerConfig,
    serviceBaseUrl,
    grafanaConfig: {
        url: grafanaUrl,
        dashboardId: grafanaDashboardId,
        dashboardName: grafanaDashboardName,
        accessToken: grafanaAccessToken
    }
};

export default config;
